import React from 'react'
import Header from '../inc/Header'
import ProthamaBuildingelevation from "../images/krsihngagar-lifespace.jpg";

function Home() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="album py-1">
        <div className="container">
          <div className='admin'>
            <img src={ProthamaBuildingelevation} className="d-block w-100" alt="bestflatrajbarikrishnagar" />
          </div>
        </div>
      </div>
      <br />
    </div>
  )
}

export default Home